import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tools/renewal-fee-calculator")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/epo-renewal-fees", statusCode: 301 });
  },
});
